import { sendGet } from './axios';

export const getAllItemJobResource = async(payload) =>{
  try{
    let data = await sendGet(`/all-resource-job-item`, payload);
    return data
  } catch(error) {
    return {data: null, message:  error.response.data.message}
  }
}

export const getAllStateForJob = (payload) => sendGet(`/job-state`, payload);

export const getAllAreaJobByState = (stateId) => sendGet(`/job-area/${stateId}`);
